/* eslint-disable react/jsx-props-no-spreading */
import type { VoidFunctionComponent } from 'react';
import { isFeatureEnabled } from '../../../helpers/features';
import { DISABLE_REPORT_UI_REFRESH } from '../../../../shared/featureFlags/flagNames';
import ReportGenerationV2 from './ReportGenerationV2';
import ReportGeneration from './ReportGeneration';
import type { ReportGenerationParams } from './shared/types';

type Props = {
  params: ReportGenerationParams,
};

/**
 * Report Generation Page for project or release group
 */
const ReportGenerationPage: VoidFunctionComponent<Props> = (props: Props) => {
  const isReportUIRefreshEnabled = !isFeatureEnabled(DISABLE_REPORT_UI_REFRESH);

  if (isReportUIRefreshEnabled) {
    return <ReportGenerationV2 {...props} />;
  }

  return <ReportGeneration {...props} />;
};

export default ReportGenerationPage;
